/* jshint esversion: 6 */
/* jshint ignore:start */
import React, { useContext, useEffect, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import EmptyImg from "../../image/emptyOrder.png";
import { useNavigate } from 'react-router-dom';
const OrderHistory = () => {

    const { t } = useTranslation();
    const { ApiBasUrl } = useContext(MyContext);

    const [bookinglist, setBookingList] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const Currency = secureLocalStorage.getItem("currency");

    useEffect(() => {
        const Userid = secureLocalStorage.getItem("Userid");
        if (Userid) {
            axios.post(`${ApiBasUrl}/service_history.php`, { uid: Userid })
                .then((res) => {
                    setBookingList(res.data.History);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("service_history.php", error);
                });
        }
    }, []);

    const formatCustomDate = (dateStr) => {

        const date = new Date(dateStr);

        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

        const dayName = days[date.getDay()];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();

        return `${dayName}, ${day} ${month}, ${year}`;
    };

    const HandleGetDetails = (service_id) => {
        navigate("/order-details");
        sessionStorage.setItem("bookid", service_id);
    };

    return (
        <div className='booking_page'>
            {loading
                ? <div className="w-full h-[100vh] bg-white fixed top-0 flex items-center justify-center">
                    <div className="loader2"></div>
                </div>
                : <div className="width_container">
                    <div className="bg-white p-[30px] py-[20px] rounded-[15px] max-_430_:p-[10px]">

                        <h1 className='font-bold text-[30px]'>{t("Orders")}</h1>
                        <p className='font-[500] text-[15px] text-gray-500'>{t("You added")} {bookinglist.length} {t("items to orders")}</p>

                        <div className="mt-[20px]">
                            <div className="flex flex-wrap items-center gap-[10px]">
                                {bookinglist.length >= 1
                                    ? bookinglist.map((item, index) => {
                                        return <div onClick={() => HandleGetDetails(item.service_id)} key={index} className="booking_box">
                                            <div className="flex items-center gap-[10px] justify-between">
                                                <h1 className='font-[500] text-[17px]'>{Currency}{item.payment_id === "5" ? item.wall_amt : item.total_amt}</h1>
                                                <button className="font-[500] text-[15px] text-[#682afb] flex items-center gap-[10px]">{t("Service ID")} : {item.service_id}</button>
                                            </div>
                                            <div className="mt-[10px] flex items-start justify-between gap-[10px]">
                                                <div className="">
                                                    <h1 className='font-[500] text-[14px] text-gray-500'>{t("SLOT SELECTED")}</h1>
                                                    <div className="flex items-center gap-[5px]">
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M12 1.25C6.072 1.25 1.25 6.072 1.25 12C1.25 17.928 6.072 22.75 12 22.75C17.928 22.75 22.75 17.928 22.75 12C22.75 6.072 17.928 1.25 12 1.25ZM12 21.25C6.899 21.25 2.75 17.101 2.75 12C2.75 6.899 6.899 2.75 12 2.75C17.101 2.75 21.25 6.899 21.25 12C21.25 17.101 17.101 21.25 12 21.25ZM15.53 14.47C15.823 14.763 15.823 15.238 15.53 15.531C15.384 15.677 15.192 15.751 15 15.751C14.808 15.751 14.616 15.678 14.47 15.531L11.47 12.531C11.329 12.39 11.25 12.199 11.25 12.001V7.00098C11.25 6.58698 11.586 6.25098 12 6.25098C12.414 6.25098 12.75 6.58698 12.75 7.00098V11.6899L15.53 14.47Z" fill="black" />
                                                        </svg>
                                                        <span className='text-[15px] max-_430_:text-[14px]'>{item.timeslot}</span>
                                                    </div>
                                                    <div className="flex items-center gap-[5px]">
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M18 3.75H16.75V3C16.75 2.586 16.414 2.25 16 2.25C15.586 2.25 15.25 2.586 15.25 3V3.75H8.75V3C8.75 2.586 8.414 2.25 8 2.25C7.586 2.25 7.25 2.586 7.25 3V3.75H6C3.582 3.75 2.25 5.082 2.25 7.5V18C2.25 20.418 3.582 21.75 6 21.75H18C20.418 21.75 21.75 20.418 21.75 18V7.5C21.75 5.082 20.418 3.75 18 3.75ZM6 5.25H7.25V6C7.25 6.414 7.586 6.75 8 6.75C8.414 6.75 8.75 6.414 8.75 6V5.25H15.25V6C15.25 6.414 15.586 6.75 16 6.75C16.414 6.75 16.75 6.414 16.75 6V5.25H18C19.577 5.25 20.25 5.923 20.25 7.5V8.25H3.75V7.5C3.75 5.923 4.423 5.25 6 5.25ZM18 20.25H6C4.423 20.25 3.75 19.577 3.75 18V9.75H20.25V18C20.25 19.577 19.577 20.25 18 20.25ZM9.02002 13C9.02002 13.552 8.57302 14 8.02002 14C7.46802 14 7.01489 13.552 7.01489 13C7.01489 12.448 7.45801 12 8.01001 12H8.02002C8.57202 12 9.02002 12.448 9.02002 13ZM13.02 13C13.02 13.552 12.573 14 12.02 14C11.468 14 11.0149 13.552 11.0149 13C11.0149 12.448 11.458 12 12.01 12H12.02C12.572 12 13.02 12.448 13.02 13ZM17.02 13C17.02 13.552 16.573 14 16.02 14C15.468 14 15.0149 13.552 15.0149 13C15.0149 12.448 15.458 12 16.01 12H16.02C16.572 12 17.02 12.448 17.02 13ZM9.02002 17C9.02002 17.552 8.57302 18 8.02002 18C7.46802 18 7.01489 17.552 7.01489 17C7.01489 16.448 7.45801 16 8.01001 16H8.02002C8.57202 16 9.02002 16.448 9.02002 17ZM13.02 17C13.02 17.552 12.573 18 12.02 18C11.468 18 11.0149 17.552 11.0149 17C11.0149 16.448 11.458 16 12.01 16H12.02C12.572 16 13.02 16.448 13.02 17ZM17.02 17C17.02 17.552 16.573 18 16.02 18C15.468 18 15.0149 17.552 15.0149 17C15.0149 16.448 15.458 16 16.01 16H16.02C16.572 16 17.02 16.448 17.02 17Z" fill="black" />
                                                        </svg>
                                                        <span className='text-[15px] max-_430_:text-[14px]'>{formatCustomDate(item.book_date)}</span>
                                                    </div>
                                                </div>
                                                <div className="">
                                                    <h1 className='font-[500] text-[14px] text-gray-500 text-end'>{t("STATUS")}</h1>
                                                    <h1 className="text-[16px] max-_430_:text-[14px]">{item.service_status}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    })
                                    : <div className="w-full h-[300px] flex items-center justify-center">
                                        <div className="text-center">
                                            <img src={EmptyImg} className='w-[250px] mx-auto' alt="EmptyImg" />
                                            <h1 className='font-bold text-[17px] text-gray-500'>{t("No service history found !!")}</h1>
                                        </div>
                                    </div>}

                            </div>
                        </div>

                    </div>
                </div>}

        </div>
    )
}

export default OrderHistory;
/* jshint ignore:end */